var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2129_5571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15C16.66 15 18 13.66 18 12C18 10.34 16.66 9 15 9C13.34 9 12 10.34 12 12C12 13.66 13.34 15 15 15ZM15 10.5C15.83 10.5 16.5 11.17 16.5 12C16.5 12.83 15.83 13.5 15 13.5C14.17 13.5 13.5 12.83 13.5 12C13.5 11.17 14.17 10.5 15 10.5ZM21.5 12.87L20.96 12.69C21.34 9.4 18.98 6.42 15.68 6.04C15.45 6.01 15.22 6 15 6C11.69 6 9.01 8.69 9.01 12C9.01 12.27 9.03 12.55 9.07 12.82C8.35 12.95 7.69 13.29 7.16 13.79C6.41 14.5 6 15.48 6 16.5V19.56C6 21.23 7.1 22.69 8.7 23.16L10.85 23.83C11.21 23.94 11.59 24 11.97 24C12.31 24 12.66 23.95 12.99 23.86L17.32 22.58C17.71 22.47 18.11 22.47 18.5 22.58L20.29 23.18C21.9 23.57 23.52 22.58 23.91 20.97C23.97 20.74 23.99 20.5 24 20.26V16.4C24 14.81 22.99 13.39 21.5 12.86V12.87ZM11.82 8.82C13.57 7.06 16.41 7.06 18.17 8.81C18.17 8.81 18.17 8.81 18.18 8.82C19.93 10.58 19.94 13.43 18.18 15.2L15.52 17.79C15.23 18.07 14.77 18.07 14.48 17.79L11.82 15.21C10.06 13.44 10.06 10.59 11.82 8.82ZM22.5 20.27C22.5 20.73 22.29 21.17 21.93 21.45C21.59 21.73 21.14 21.83 20.71 21.75L18.95 21.16C18.28 20.97 17.58 20.96 16.91 21.15L12.57 22.43C12.15 22.55 11.71 22.54 11.3 22.41L9.13 21.73C8.17 21.45 7.5 20.57 7.5 19.56V16.5C7.5 15.89 7.75 15.3 8.19 14.88C8.53 14.55 8.97 14.34 9.44 14.28C9.74 15.03 10.19 15.71 10.76 16.28L13.44 18.87C14.31 19.72 15.7 19.72 16.57 18.87L19.24 16.27C19.84 15.67 20.3 14.95 20.6 14.15L21 14.28C21.89 14.6 22.49 15.45 22.49 16.4V20.26L22.5 20.27Z",
    fill: "#767676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2129_5571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSite);
export default __webpack_public_path__ + "static/media/ico-site.fc9427263f23707198b7f80e0d9457d9.svg";
export { ForwardRef as ReactComponent };